import React, {useCallback, useEffect, useRef, useState} from "react";

const Particle: React.FC<any> = (props) => {
    const {
        height = 0
     } = props
     
    const canvasRef = useRef<HTMLCanvasElement | null>(null)
    const [warea, setWarea] = useState<any>({x: null, y: null, max: 2000})
    const [ctx, setCtx] = useState<any>(null)
    const [dots, setDots] = useState<any[]>([])
    const [isAnimate, setIsAnimate] = useState<boolean>(false)
    const canvas = canvasRef?.current

    useEffect(() => {
        if (canvasRef?.current) {
            setCtx(canvasRef?.current?.getContext('2d'))
        }
    }, [canvasRef]);

    useEffect(() => {
        // 添加粒子
        // x，y为粒子坐标，xa, ya为粒子xy轴加速度，max为连线的最大距离
        if (ctx && dots.length === 0) {
            resize()
            const dots = [];
            for (let i = 0; i < 150; i++) {
                // @ts-ignore
                let x = Math.random() * canvas.width;
                // @ts-ignore
                let y = Math.random() * canvas.height;
                let xa = Math.random() * 2 - 1;
                let ya = Math.random() * 2 - 1;

                dots.push({
                    x: x,
                    y: y,
                    xa: xa,
                    ya: ya,
                    max: 6000
                })
                setDots(dots)
            }
        }
    }, [dots, canvas, canvas?.height, canvas?.width, ctx]);

    const resize = useCallback(() => {
        if (ctx && canvas?.width && canvas?.height) {
            canvas.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            // canvas.height = height || window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            canvas.height = height
        }
    }, [canvas, ctx, height])

    const RAF = (function () {
        return window.requestAnimationFrame 
        // @ts-ignore
        || window.webkitRequestAnimationFrame 
        // @ts-ignore
        || window.mozRequestAnimationFrame 
        // @ts-ignore
        || window.oRequestAnimationFrame 
        // @ts-ignore
        || window.msRequestAnimationFrame 
        || function(callback) {
                window.setTimeout(callback, 1000 / 60);
            };
    })()

    const animate = useCallback(() => {
        // @ts-ignore
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // 将鼠标坐标添加进去，产生一个用于比对距离的点数组
        const ndots = [warea].concat(dots);

        dots.forEach(function(dot) {

            // 粒子位移
            dot.x += dot.xa;
            dot.y += dot.ya;

            // 遇到边界将加速度反向
            // @ts-ignore
            dot.xa *= (dot.x > canvas.width || dot.x < 0) ? -1 : 1;
            // @ts-ignore
            dot.ya *= (dot.y > canvas.height || dot.y < 0) ? -1 : 1;

            // 绘制点
            ctx.fillRect(dot.x - 0.5, dot.y - 0.5, 1, 1);

            // 循环比对粒子间的距离
            for (let i = 0; i < ndots.length; i++) {
                const d2 = ndots[i];

                if (dot === d2 || d2.x === null || d2.y === null) continue;

                const xc = dot.x - d2.x;
                const yc = dot.y - d2.y;

                // 两个粒子之间的距离
                const dis = xc * xc + yc * yc;

                // 距离比
                let ratio;

                // 如果两个粒子之间的距离小于粒子对象的max值，则在两个粒子间画线
                if (dis < d2.max) {

                    // 如果是鼠标，则让粒子向鼠标的位置移动
                    if (d2 === warea && dis > (d2.max / 2)) {
                        dot.x -= xc * 0.03;
                        dot.y -= yc * 0.03;
                    }

                    // 计算距离比
                    ratio = (d2.max - dis) / d2.max;

                    // 画线
                    ctx.beginPath();
                    ctx.lineWidth = ratio / 2;
                    ctx.strokeStyle = 'rgba(0,0,0,' + (ratio + 0.2) + ')';
                    ctx.moveTo(dot.x, dot.y);
                    ctx.lineTo(d2.x, d2.y);
                    ctx.stroke();
                }
            }

            // 将已经计算过的粒子从数组中删除
            ndots.splice(ndots.indexOf(dot), 1);
        });

        RAF(animate);
    }, [canvas?.height, canvas?.width, ctx, dots, warea])

    useEffect(() => {
        if (isAnimate) {
            RAF(animate)
            setIsAnimate(false)
        }
    }, [RAF, animate, isAnimate]);

    useEffect(() => {
        let timeout = null
        if (dots?.length) {
            timeout = setTimeout(() => {
                animate()
            }, 1000)
        }
    }, [dots]);

    useEffect(() => {
        if (ctx) {
            window.addEventListener('resize', resize)
        }
        return () => {
            window.removeEventListener('resize', resize)
        }
    }, [canvas, ctx]);

    return (
        <canvas ref={canvasRef} />
    )
}

export default React.memo(Particle)